import { render, staticRenderFns } from "./ConnectWalletClaimer.vue?vue&type=template&id=35ec2474&"
import script from "./ConnectWalletClaimer.vue?vue&type=script&lang=js&"
export * from "./ConnectWalletClaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports